/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Faq_2_QInputs */

const en_vc_faq_2_q = /** @type {(inputs: Vc_Faq_2_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can VectorCraft open Adobe Illustrator .ai files?`)
};

const zh_vc_faq_2_q = /** @type {(inputs: Vc_Faq_2_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft 能打开 Adobe Illustrator 的 .ai 文件吗？`)
};

/**
* | output |
* | --- |
* | "Can VectorCraft open Adobe Illustrator .ai files?" |
*
* @param {Vc_Faq_2_QInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_faq_2_q = /** @type {((inputs?: Vc_Faq_2_QInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Faq_2_QInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_faq_2_q(inputs)
	return zh_vc_faq_2_q(inputs)
});
export { vc_faq_2_q as "vc.faq.2.q" }